export default {
  SHOW_BACKDROP: "backdrop/show",
  HIDE_BACKDROP: "backdrop/hide"
}